// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/turn-rate.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/turn-rate/rate-one-turn-bank-angle.js';
import g1 from '../lessons/aeronautics/turn-rate/turn-performance.js';
import g2 from '../lessons/aeronautics/turn-rate/turn-rate.js';

mount([g0, g1, g2]);
